// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-0b76e46e]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.add_coupon_dialog[data-v-0b76e46e] {\n  background: #fff;\n  padding: 10px;\n}\n.add_coupon_dialog h2[data-v-0b76e46e] {\n  margin-bottom: 20px;\n  font-weight: 700;\n  text-align: center;\n}\n.add_coupon_dialog .intro[data-v-0b76e46e] {\n  margin: 10px 0;\n}", ""]);
// Exports
module.exports = exports;
